module.exports = __webpack_public_path__ + "static/media/flag-empty.63ff21c2.svg";